import SevenRooms from '../../../images/SevenRooms.png';

export const SevenRoomsIcon = () => (
  <div className="order-res-links-icon">
    <img src={SevenRooms} alt="SevenRooms" />
  </div>
);

export default SevenRoomsIcon;
